import { render, staticRenderFns } from "./costHelpSixtyTage.vue?vue&type=template&id=d8570080&"
import script from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8570080')) {
      api.createRecord('d8570080', component.options)
    } else {
      api.reload('d8570080', component.options)
    }
    module.hot.accept("./costHelpSixtyTage.vue?vue&type=template&id=d8570080&", function () {
      api.rerender('d8570080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-268mzVIqTumMG/JS/costHelpSixtyTage.vue"
export default component.exports